let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2Rsgm")).then(() => parcelRequire('xZZ6W'));